import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-673111e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-content" }
const _hoisted_2 = {
  key: 0,
  class: "live-info hold"
}
const _hoisted_3 = { class: "time" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, "直播暂未开始..", -1))
const _hoisted_5 = {
  key: 1,
  class: "live-info living"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "recorded-pages"
}
const _hoisted_8 = {
  key: 1,
  class: "live-info finished"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, "直播结束,回放待更新", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "live-desc"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "直播内容介绍", -1))


import {CourseLivePlan} from "@/models/live/courseLivePlan";
import {UserCourseLivePage} from "@/models/live/userCourseLivePage";
import useDateConvert from "@/composables/useDateConvert";
import {VideoCamera, Clock} from '@element-plus/icons'
import {pageMap} from "@/components/pages";
import {fetchLiveUrl} from "@/apis/live";
import {ElMessage} from "element-plus";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLiveContent',
  props: {
    courseId: {},
    partId: {},
    live: {},
    pages: {}
  },
  setup(__props: any) {

const props = __props

const {convertDatetime} = useDateConvert()

const handleEntry = async (liveId: number) => {
  const res = await fetchLiveUrl(liveId)
  if (res?.code === 200) {
    window.open(res.data.url)
  } else {
    ElMessage.error(res?.msg);
  }
}

const handleCountTime = ({pageId, time}: { pageId: number, time: number }) => {
  console.log("观看时长", time, "pageId", pageId)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.live.status === 'NORMAL')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Clock), { class: "icon" }),
            _createTextVNode(" 直播时间：" + _toDisplayString(_unref(convertDatetime)(_ctx.live.openTime)), 1)
          ]),
          _hoisted_4
        ]))
      : (_ctx.live.status === 'ING' || _ctx.live.status === 'READY')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleEntry(_ctx.live.id)))
            }, [
              _createVNode(_unref(VideoCamera), { class: "icon" }),
              _createTextVNode(" 进入直播间 ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.pages?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageMap)[page.page.type]), {
                      page: page.page,
                      userPage: page,
                      courseId: _ctx.courseId,
                      partId: _ctx.partId,
                      pageId: page.id,
                      key: 'page' + page.id,
                      onCountTime: handleCountTime
                    }, null, 40, ["page", "userPage", "courseId", "partId", "pageId"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          ])),
    (_ctx.live.liveDesc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("p", null, _toDisplayString(_ctx.live.liveDesc), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})